// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const HEARTS_LINK_LABEL = "Srd\u00ed\u010dka";
export const MESSAGES_LINK_LABEL = "Zpr\u00e1vy";
export const NOTIFICATIONS = "Upozorn\u011bn\u00ed";
